// #

import { TShop } from 'redux/reducers/shops/types';
import {
	ETableStructureAlign,
	ETableStructureType,
	TTableStructure,
} from 'services/constants/tableStructureTypes';

export const tableStructure: TTableStructure<keyof TShop>[] = [
	{
		name: 'Shop Id',
		selector: 'id' as keyof TShop,
		show: false,
		sortable: true,
		filterable: false,
		filter: [['text']],
		colSpan: 1,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Shop Name',
		selector: 'name' as keyof TShop,
		show: true,
		sortable: true,
		filterable: false,
		filter: [['text']],
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Shop Type',
		selector: 'type' as keyof TShop,
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.CENTER,
		filter: [
			['WooCommerce', 'WooCommerce'],
			['Magento', 'Magento'],
		],
	},
	{
		name: 'Status',
		selector: 'state' as keyof TShop,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			['ProductsMigrationStarted', 'Goods are being parsed'],
			['ProductsMigrated', 'Goods have been parsed'],
			['Completed', 'Completed'],
			['New', 'New'],
			['Failed', 'Failed'],
		],
		colors: [
			['ProductsMigrationStarted', 'warning.light'],
			['ProductsMigrated', 'success.light'],
			['Completed', 'info.light'],
			['New', 'info.light'],
			['Failed', 'error.light'],
		],
	},

	{
		name: 'Actions',
		selector: 'actions' as keyof TShop,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.LEFT,
		buttons: ['Download File'],
		buttonFilter: (item: TShop) => {
			if (item.state === 'ProductsMigrated') {
				return ['Delete Shop'];
			}
			if (item.state === 'New') {
				return ['Map Fields', 'Delete Shop'];
			}
			if (item.state === 'Completed') {
				return ['Start Parsing', 'Delete Shop'];
			}
			if (item.state === 'Failed') {
				return ['Restart products migration'];
			}
			return ['Delete Shop'];
		},
	},
	{
		name: '',
		selector: 'customComponent' as keyof TShop,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 3,
		type: ETableStructureType.CUSTOM,
		align: ETableStructureAlign.LEFT,
	},
];
